import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Spin, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchEscalationMatrix } from "../../Action/Actions";
import { ExportOutlined } from "@ant-design/icons";
import DataTable from "../DataTable/DataTable";
import * as XLSX from "xlsx";
import { useSelectedYear } from "../../Context/SelectYearContext";
import { getUserData } from "../login/LoginSlice";

const RiskLocation = () => {
  const dispatch = useDispatch();
  const [activityData, setActivityData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { selectedYear } = useSelectedYear();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [escalationData, setEscalationData] = useState({});
  const [activeTab, setActiveTab] = useState('defaultTab');
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const user = useSelector(getUserData);

  const AuthData = useSelector(state => state.auth);

  useEffect(() => {
    const fetchEscalationData = async () => {
      try {
        if (AuthData?.corporate_id) {
          setLoading(true);
          const data = await dispatch(
            fetchEscalationMatrix(AuthData?.corporate_id)
          );
          const { policy_escalation_matrix } = data;
          setEscalationData(policy_escalation_matrix || {});
          const firstPolicyNumber =
            policy_escalation_matrix[activeTab]?.[0]?.policy_number;
          setSelectedPolicyNumber(firstPolicyNumber || null);
        }
      } catch (err) {
        console.error("Error fetching escalation matrix:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEscalationData();
  }, [dispatch, AuthData, activeTab]); // Added dependencies

  const handleTableChange = (newPagination) => {
    setPagination({
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      total: pagination.total,
    });
  };

  const columns = [
    {
      title: "SI NO",
      dataIndex: "si_no",
      key: "si_no",
      render: (_, __, index) => {
        const pageIndex = pagination.current || 1;
        const pageSize = pagination.pageSize || 10;
        return (pageIndex - 1) * pageSize + index + 1;
      },
    },
    {
      title: "LOCATION ADDRESS",
      dataIndex: "location_address",
      key: "location_address",
    },
    {
      title: "BIFURCATION OF SUM-INSURED",
      dataIndex: "bifurcation_of_sum_insured",
      key: "bifurcation_of_sum_insured",
    },
    {
      title: "TOTAL SUM INSURED",
      dataIndex: "total_sum_insured",
      key: "total_sum_insured",
    },
    {
      title: "CREATED AT",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  const handleExport = () => {
    const exportData = activityData.map((item, index) => ({
      "SI NO": (pagination.current - 1) * pagination.pageSize + index + 1,
      "LOCATION ADDRESS": item.location_address,
      "BIFURCATION OF SUM-INSURED": item.bifurcation_of_sum_insured,
      "TOTAL SUM INSURED": item.total_sum_insured,
      "CREATED AT": item.created_at,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RiskLocationList");
    XLSX.writeFile(wb, "RiskLocationList.xlsx");
  };

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-heading">Risk Location List</div>
        <div className="escalation-content">
          <Row className="escalation-row-header">
          <span style={{ fontWeight: "700", fontSize: "20px" }}>
            {user?.corporate_name || "Guest"}
            </span>{" "}
            <span style={{ marginLeft: "8px" }}>
              (Financial Year: {selectedYear})
            </span>
          </Row>
          <Card>
            <Row
              gutter={16}
              className="mb-3 justify-content-between align-items-center px-3"
              style={{
                display: "flex",
                justifySelf: "flex-end",
                marginTop: "16px",
              }}
            >
              <Col xs={24} sm={2} md={2} lg={2} xl={2}>
                <Button
                  type="primary"
                  icon={<ExportOutlined />}
                  className="d-flex"
                  onClick={handleExport}
                >
                  Export
                </Button>
              </Col>
            </Row>

            <DataTable
              columns={columns}
              dataSource={activityData}
              rowKey="id"
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: activityData.length,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                onChange: (page, pageSize) =>
                  handleTableChange({ current: page, pageSize }),
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              }}
            />
          </Card>
        </div>
      </div>
    </Spin>
  );
};

export default RiskLocation;